import { CHAT_STRINGS, ChatPanel } from '@modules/chat'
import { PUBLISHER_EXPAND_PRESETS } from '@publisher/modules/api'
import { useChatModalContext } from './contexts/chat-modal/ChatModalProvider'

export const Chat = ({ closed }: { closed: boolean }) => {
  const { requestId } = useChatModalContext()

  if (!requestId) {
    return null
  }

  return (
    <ChatPanel
      commentsResource={`publisher-request/${requestId}/comments`}
      postUrl={`/publisher-request/${requestId}/comments`}
      filesRequestId={Number(requestId) || 0}
      meta={PUBLISHER_EXPAND_PRESETS.FILES_ONLY}
      closed={closed}
      findAuthor={comment => comment.commenter ?? CHAT_STRINGS.halLeonard}
    />
  )
}
